import React, { useState } from 'react';
import { CheckCircleIcon, CameraIcon, FileIcon, AlertCircleIcon } from 'lucide-react';
import { TokenConfirmation } from './TokenConfirmation';
import { FileUploader } from './FileUploader';
export const NegotiationRegister = ({
  simulationData
}) => {
  const [step, setStep] = useState('details');
  const [files, setFiles] = useState([]);
  const handleFileUpload = newFiles => {
    setFiles([...files, ...newFiles]);
  };
  const handleRemoveFile = index => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };
  const handleContinue = () => {
    setStep('confirmation');
  };
  const handleConfirmation = () => {
    setStep('success');
  };
  if (!simulationData) {
    return <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6" data-id="element-876">
        <div className="flex items-start" data-id="element-877">
          <AlertCircleIcon className="h-6 w-6 text-yellow-500 mr-3 mt-0.5" data-id="element-878" />
          <div data-id="element-879">
            <h3 className="text-lg font-medium text-yellow-800" data-id="element-880">
              No hay simulación activa
            </h3>
            <p className="mt-2 text-sm text-yellow-700" data-id="element-881">
              Por favor, realice una simulación en la pestaña anterior antes de
              continuar con el registro.
            </p>
          </div>
        </div>
      </div>;
  }
  if (step === 'success') {
    return <div className="bg-green-50 border border-green-200 rounded-lg p-8 text-center" data-id="element-882">
        <CheckCircleIcon className="h-16 w-16 text-green-500 mx-auto mb-4" data-id="element-883" />
        <h2 className="text-2xl font-bold text-green-700 mb-2" data-id="element-884">
          ¡Negociación Registrada con Éxito!
        </h2>
        <p className="text-green-600 mb-6" data-id="element-885">
          La negociación ha sido registrada correctamente y se ha enviado una
          copia al correo del cliente.
        </p>
        <div className="bg-white rounded-lg p-4 max-w-md mx-auto" data-id="element-886">
          <p className="font-medium text-gray-900" data-id="element-887">
            Número de Acuerdo: #AC-2024-0589
          </p>
          <p className="text-sm text-gray-500 mt-2" data-id="element-888">
            Un asesor se pondrá en contacto con el cliente en las próximas 24
            horas para confirmar los detalles.
          </p>
        </div>
      </div>;
  }
  if (step === 'confirmation') {
    return <TokenConfirmation onConfirm={handleConfirmation} onCancel={() => setStep('details')} data-id="element-889" />;
  }
  return <div className="space-y-8" data-id="element-890">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-891">
        <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-892">
          Detalles de la Negociación
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-893">
          <div data-id="element-894">
            <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-895">Cliente</h3>
            <div className="space-y-2" data-id="element-896">
              <div className="flex justify-between" data-id="element-897">
                <span className="text-sm text-gray-500" data-id="element-898">Nombre</span>
                <span className="text-sm font-medium" data-id="element-899">Juan Pérez Gómez</span>
              </div>
              <div className="flex justify-between" data-id="element-900">
                <span className="text-sm text-gray-500" data-id="element-901">Identificación</span>
                <span className="text-sm font-medium" data-id="element-902">DNI: 12345678</span>
              </div>
              <div className="flex justify-between" data-id="element-903">
                <span className="text-sm text-gray-500" data-id="element-904">Contacto</span>
                <span className="text-sm font-medium" data-id="element-905">987654321</span>
              </div>
            </div>
          </div>
          <div data-id="element-906">
            <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-907">Acuerdo</h3>
            <div className="space-y-2" data-id="element-908">
              <div className="flex justify-between" data-id="element-909">
                <span className="text-sm text-gray-500" data-id="element-910">Deuda Original</span>
                <span className="text-sm font-medium" data-id="element-911">
                  S/ {simulationData.totalDebt.toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-912">
                <span className="text-sm text-gray-500" data-id="element-913">Descuento</span>
                <span className="text-sm font-medium text-green-600" data-id="element-914">
                  S/ {simulationData.discountAmount.toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-915">
                <span className="text-sm text-gray-500" data-id="element-916">Total a Pagar</span>
                <span className="text-sm font-medium" data-id="element-917">
                  S/ {simulationData.totalPayment.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-918">
          <div data-id="element-919">
            <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-920">
              Forma de Pago
            </h3>
            <div className="space-y-2" data-id="element-921">
              <div className="flex justify-between" data-id="element-922">
                <span className="text-sm text-gray-500" data-id="element-923">Cuota Inicial</span>
                <span className="text-sm font-medium" data-id="element-924">
                  S/ {simulationData.initialPayment.toFixed(2)}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-925">
                <span className="text-sm text-gray-500" data-id="element-926">Número de Cuotas</span>
                <span className="text-sm font-medium" data-id="element-927">
                  {simulationData.term}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-928">
                <span className="text-sm text-gray-500" data-id="element-929">Valor de Cuota</span>
                <span className="text-sm font-medium" data-id="element-930">
                  S/ {simulationData.monthlyPayment.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
          <div data-id="element-931">
            <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-932">Fechas</h3>
            <div className="space-y-2" data-id="element-933">
              <div className="flex justify-between" data-id="element-934">
                <span className="text-sm text-gray-500" data-id="element-935">Fecha Acuerdo</span>
                <span className="text-sm font-medium" data-id="element-936">
                  {new Date().toLocaleDateString()}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-937">
                <span className="text-sm text-gray-500" data-id="element-938">Primer Pago</span>
                <span className="text-sm font-medium" data-id="element-939">
                  {new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString()}
                </span>
              </div>
              <div className="flex justify-between" data-id="element-940">
                <span className="text-sm text-gray-500" data-id="element-941">Último Pago</span>
                <span className="text-sm font-medium" data-id="element-942">
                  {new Date(Date.now() + (simulationData.term * 30 + 7) * 24 * 60 * 60 * 1000).toLocaleDateString()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-943">
        <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-944">
          Documentación de Soporte
        </h2>
        <div className="mb-6" data-id="element-945">
          <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-946">
            Cargar Documentos
          </h3>
          <FileUploader onUpload={handleFileUpload} data-id="element-947" />
        </div>
        {files.length > 0 && <div data-id="element-948">
            <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-949">
              Archivos Cargados
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4" data-id="element-950">
              {files.map((file, index) => <div key={index} className="bg-gray-50 rounded-lg p-3 flex items-center" data-id="element-951">
                  {file.type.startsWith('image/') ? <CameraIcon className="h-5 w-5 text-blue-500 mr-3" data-id="element-952" /> : <FileIcon className="h-5 w-5 text-blue-500 mr-3" data-id="element-953" />}
                  <div className="flex-1 min-w-0" data-id="element-954">
                    <p className="text-sm font-medium text-gray-900 truncate" data-id="element-955">
                      {file.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-956">
                      {(file.size / 1024).toFixed(1)} KB
                    </p>
                  </div>
                  <button onClick={() => handleRemoveFile(index)} className="text-gray-400 hover:text-red-500" data-id="element-957">
                    <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-958">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-959" />
                    </svg>
                  </button>
                </div>)}
            </div>
          </div>}
      </div>
      <div className="flex justify-end" data-id="element-960">
        <button onClick={handleContinue} className="px-8 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 font-medium" data-id="element-961">
          Continuar
        </button>
      </div>
    </div>;
};